import { Heading } from 'components/v2/Typography/Heading';
import styled from 'styled-components';

export const Form = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ConfirmDetailsWrapper = styled.div`
  padding-bottom: 30px;
`;

export const StepHeadingContainer = styled.div`
  padding: 16px 0 0 0;
`;

export const StepHeading = styled(Heading).attrs({ tag: 'h2', styledAs: 'h2' })`
  justify-content: center;
  text-align: center;
  margin-bottom: 0;
  padding-bottom: 0;
`;

export const StepWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`;
